import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from '@mui/material';
import { organizationApi } from '../../../services/api';
import { useAlert } from '../../../contexts/AlertContext';
import { CONTRACT_TYPE_RETURN_TYPES } from '../../../constants/selectorReturnTypes';

// Legacy export for backward compatibility
export const RETURN_VALUE_TYPES = CONTRACT_TYPE_RETURN_TYPES;

const EmployeeContractTypeSelector = ({ 
  value, 
  onChange, 
  label = "Contract Type",
  required = false,
  disabled = false,
  fullWidth = true,
  returnValue = CONTRACT_TYPE_RETURN_TYPES.ID, // CONTRACT_TYPE_RETURN_TYPES.ID or CONTRACT_TYPE_RETURN_TYPES.NAME
  ...props 
}) => {
  const [contractTypes, setContractTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { showAlert } = useAlert();

  useEffect(() => {
    const fetchContractTypes = async () => {
      try {
        setIsLoading(true);
        const contractTypesData = await organizationApi.getEmployeeContractTypes();
        setContractTypes(contractTypesData || []);
      } catch (error) {
        showAlert('Failed to load employee contract types', 'error', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchContractTypes();
  }, [showAlert]);

  const handleChange = (event) => {
    const selectedId = event.target.value;
    
    if (onChange) {
      if (returnValue === CONTRACT_TYPE_RETURN_TYPES.NAME) {
        const contractType = contractTypes.find(type => type.id === selectedId);
        onChange(contractType?.name || '');
      } else {
        onChange(selectedId || '');
      }
    }
  };

  // Find the selected contract type for value display
  const selectedValue = (() => {
    if (!value) return '';
    
    if (returnValue === CONTRACT_TYPE_RETURN_TYPES.NAME) {
      const contractType = contractTypes.find(type => type.name === value);
      return contractType?.id || '';
    } else {
      return value;
    }
  })();

  return (
    // ADR-173 D3 — `required` reaches the FormControl so the label carries its asterisk
    <FormControl fullWidth={fullWidth} required={required} disabled={disabled || isLoading} {...props}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={selectedValue}
        onChange={handleChange}
        label={label}
        disabled={disabled || isLoading}
        endAdornment={isLoading ? <CircularProgress size={20} /> : null}
      >
        {!required && (
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
        )}
        {contractTypes.map(type => (
          <MenuItem key={type.id} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default EmployeeContractTypeSelector; 